import { css } from 'linaria';

export const BannersCarouselSliderWrapperStyles = css`
  display: block;
  position: relative;
  width: 100%;
  max-width: 100vw;
`;
